<bn-loading-overlay></bn-loading-overlay>


<div class="container" *ngIf="validacaoScr; else carregando">

    <div class="row">
        <div class="col">
            <h3>Detalhes da validação SCR <small class="text-muted">(#ID: {{validacaoScr?.id}})</small></h3>
        </div>
        <div class="col-auto">
            <button class="btn btn-primary" type="button" (click)="voltarParaLista ()">Voltar</button>
        </div>
    </div>
    <div class="row">
        <div class="bn-form-group col-md-4">
            <label><b>Tipo de validação</b></label>
            <input type="text" class="form-control" name="tipoValidacao"
                value="{{labelTipoValidacaoScr(validacaoScr.tipoValidacao)}}" disabled />
        </div>
        <div class="bn-form-group col-md-3">
            <label><b>Data da validação</b></label>
            <input type="text" class="form-control" name="dataValidacao" value="{{validacaoScr.dataValidacao  | date:'dd/MM/yyyy HH:mm'}}" disabled />
        </div>
        <div class="bn-form-group col-md-2">
            <label><b>Qtde. SHs sucesso</b></label>
            <input type="text" class="form-control" name="qtdeShsSucesso" value="{{validacaoScr.qtdeSolicitacoesHonraValidadasComSucesso}}" disabled />
        </div>
        <div class="bn-form-group col-md-2">
            <label><b>Qtde. SHs erro</b></label>
            <input type="text" class="form-control" name="qtdeShsErro" value="{{validacaoScr.qtdeSolicitacoesHonraValidadasComErro}}" disabled />
        </div>
    </div>
    <div class="row">
        <div class="bn-form-group col-md-4">
            <div class="d-flex flex-column">
                <label><b>Apenas validadas com erro</b></label>
                <input type="checkbox" class="form-check-input checkbox-gigante" name="exibirApenasComErro" [(ngModel)]="exibirApenasComErro" (change)="checkBoxChanged($event)"/>
            </div>
        </div>
        <div class="bn-form-group col-md-4">
            <label><b>Id. externo operação: </b> <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                ngbTooltip="Identificador do protocolo da operação informado pelo Agente Financeiro em operações Crédito Livre."></i>
            </label>
            <input class="form-control" name="idExternoOperacao" [(ngModel)]="idExternoOperacao" (change)="inputTextChanged($event)">
        </div>
        <div class="bn-form-group col-md-3">
            <label><b>Contrato: </b> <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                ngbTooltip="Número do contrato, constante dos Boletos de Cobrança enviados pelo BNDES."></i>
            </label>
            <input class="form-control" name="contrato" [(ngModel)]="contrato" (change)="inputTextChanged($event)">
        </div>
    </div>
    <br>
    <div class="row">
        <div class="col">
            <h5>Solicitações de honra validadas</h5>
        </div>
    </div>

    <div class="container" *ngIf="pesquisado">
        <div class="alert alert-info" *ngIf="!validacoesShScrBuscadas || !validacoesShScrBuscadas.length">
            Não foram encontradas Solicitações de Honra validadas com {{exibirApenasComErro ? 'Erro' : 'Sucesso'}}.
        </div>
        <bn-paginacao *ngIf = "validacoesShScrBuscadas && validacoesShScrBuscadas.length > 0" [total]="atributosPaginacaoSolicitacoesListagem.count"
        [tamanhoPagina]="atributosPaginacaoSolicitacoesListagem.pageSize" [numPagina]="atributosPaginacaoSolicitacoesListagem.page"
        [opcoesTamanhoPagina]="opcoesPaginacao">
            <div class="table-responsive">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th scope="col">
                                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'idSolicitacaoHonra'"
                                    [nomeAtributoExibicao]="'Id. Sol. Honra'" (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>
                            <th scope="col">
                                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'nomeJanela'"
                                    [nomeAtributoExibicao]="'Janela'" (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>
                            <th scope="col">
                                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'cnpjAgenteFinanceiro'"
                                    [nomeAtributoExibicao]="'Agente Financeiro'" (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>
                            <th scope="col">
                                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'self'"
                                    [nomeAtributoExibicao]="'Operação/Contrato'" (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>
                            <th scope="col" class="titulo-moeda" *ngIf="validacaoScr.tipoValidacao == 'I' || validacaoScr.tipoValidacao == 'N'">
                                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'validacaoIndicioRecuperacaoCredito.valorRecuperadoMesAtual'"
                                    [nomeAtributoExibicao]="'Valor recuperado no mês (R$)'" (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>
                            <th scope="col" class="titulo-moeda" *ngIf="validacaoScr.tipoValidacao == 'I' || validacaoScr.tipoValidacao == 'N'">
                                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'validacaoIndicioRecuperacaoCredito'"
                                    [nomeAtributoExibicao]="'Variação do saldo no mês no SCR (R$)'" (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>
                            <th scope="col">
                                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'possuiErrosDeValidacao'"
                                    [nomeAtributoExibicao]="'Sucesso?'" (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>
                            <th scope="col"></th> <!--icones para ver mais detalhes por registro-->
                        <tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let validacaoShScr of validacoesShScrBuscadas">
                            <td>{{ validacaoShScr.idSolicitacaoHonra}}</td>
                            <td>{{ validacaoShScr.nomeJanela}}</td>
                            <td>{{ nomeAgente(validacaoShScr.cnpjAgenteFinanceiro) }}</td>
                            <td>{{ validacaoShScr.idOperacaoAgenteCreditoLivre ? validacaoShScr.idOperacaoAgenteCreditoLivre : validacaoShScr.contratoRepasse}}</td>
                            <td class="moeda" *ngIf="validacaoScr.tipoValidacao == 'I' || validacaoScr.tipoValidacao == 'N'">{{validacaoShScr.validacaoIndicioRecuperacaoCredito?.valorRecuperadoMesAtual | bnMask:'MOEDA'}}</td>
                            <td class="moeda" *ngIf="validacaoScr.tipoValidacao == 'I' || validacaoScr.tipoValidacao == 'N'">{{validacaoShScr.validacaoIndicioRecuperacaoCredito ? ((validacaoShScr.validacaoIndicioRecuperacaoCredito.valorTotalDividaMesAtual - validacaoShScr.validacaoIndicioRecuperacaoCredito.valorTotalDividaMesAnterior) | bnMask:'MOEDA') : ''}}</td>
                            <td>{{ validacaoShScr.possuiErrosDeValidacao ? "Não" : "Sim"}}</td>
                            <td>
                                <a href="javascript:void(0)" (click)="exibirPopupComArquivosScr(validacaoShScr.idSolicitacaoHonra)"> 
                                    <i class="fas fa-folder-open margin-left-5" placement="left-top" ngbTooltip="Exibir arquivos SCR utilizados"></i>
                                </a>
                            <a href="javascript:void(0)" (click)="exibirPopupComErros(validacaoShScr.idSolicitacaoHonra)" *ngIf="validacaoShScr.possuiErrosDeValidacao"> 
                                    <i class="fas fa-exclamation-circle margin-left-5" placement="left-top" ngbTooltip="Exibir erros de validação"></i>
                            </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </bn-paginacao>
    </div>
</div>

<ng-template #arquivosScr>
    <div class="table-responsive">
        <table class="table table-hover">
            <thead>
                <tr>
                    <th scope="col">Id Arquivo SCR</th>
                    <th scope="col">Data Base SCR</th>
                    <th scope="col">Id. Operação SCR</th>
                    <th scope="col">Troca IPOC</th>
                    <!--<th scope="col">IPOC antigo</th>-->
                    <th scope="col">IPOC novo</th>
                <tr>
            </thead>
            <tbody>
                <tr *ngFor="let arquivo of arquivosShScr">
                    <td>{{ arquivo.arquivoScrUtilizadoNaValidacao?.id}}</td>
                    <!-- scr.referencia+'-01' e' porque o pipe date trabalha com valores yyyy-MM-dd, como estao vindo somente yyyy-MM, estou adicionando o dia como 01-->
                    <td>{{ arquivo.arquivoScrUtilizadoNaValidacao ? (arquivo.arquivoScrUtilizadoNaValidacao.referencia+'-01' | date:'MM/yyyy') : '' }}</td>
                    <td>{{ arquivo.operacaoScrUtilizadaNaValidacao?.id}}</td>
                    <td>{{ arquivo.trocaIpoc ? 'Sim' : 'Não'}}</td>
                    <!--<td>{{ arquivo.ipocAntigo}}</td>-->
                    <td>{{ arquivo.ipocNovo}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</ng-template>

<ng-template #errosValidacao>
    <div class="table-responsive">
        <table class="table-striped table-bordered">
            <tbody>
                <tr *ngFor="let erro of errosValidacaoScr">
                    <td>{{ erro.mensagem }}</td>
                </tr> 
            </tbody>
        </table>
    </div>
</ng-template>

<ng-template #botoesDeAcao>
    <button class="btn btn-default" (click)="fecharPopup()">Fechar</button>
</ng-template>

<ng-template #carregando>
  <div class="loading-pesquisa">
    <i class="bn-loading"></i>
  </div>
</ng-template>
